<div class="modal-header">
  <h4 class="modal-title">{{ pageTitle }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <h4 class="title">
    <label [translate]="'TITLES.COUNTRY'">Country: </label>&nbsp;
    <strong class="text-capitalize">{{ quotation.country }}</strong>
  </h4>

  <h5 *ngIf="isChecking" [translate]="'LABELS.QUOTE_NEG_CHECKING'">
    <i class="fas fa-spinner spin"></i> Checking previously sent price
    negotiation...
  </h5>

  <fieldset *ngIf="negotiatedPrice">
    <legend>
      {{ 'LABELS.QUOTE_NEG_EXISTS' | translate }}
      {{ negotiatedPrice.created_at | date: 'medium' }}
    </legend>

    <div class="row">
      <div class="col-md-12 form-group">
        <label for="" [translate]="'TITLES.PRODUCT_VARIANTS'"></label>
        <div class="rfq-variants">
          <div
            class="form-group"
            *ngFor="
              let variant of negotiatedPrice.variants | keyvalue;
              let i = index
            "
          >
            <label class="text-capitalize">{{ variant.key }}</label>
            <span class="form-control">{{ variant.value }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">
        <div class="form-group">
          <label for="" [translate]="'LABELS.COST_PER_UNIT'"
            >Total Cost Per Unit</label
          >
          <span class="form-control">{{ negotiatedPrice.cost_per_unit }}</span>
        </div>
        <div class="form-group">
          <label for="" [translate]="'LABELS.QUOTE_NEG_VOLUME'"
            >How many units will you be purchasing?</label
          >
          <span class="form-control">{{ negotiatedPrice.unit_quantity }}</span>
        </div>
      </div>
      <div class="col-md-7">
        <div class="form-group" *ngIf="negotiatedPrice.logistics">
          <label for="" [translate]="'LABELS.LOGISTICS'">Logistics</label>
          <span class="form-control">{{
            settingsSvc.getLogistics()[negotiatedPrice.logistics]
          }}</span>
        </div>

        <div class="form-group">
          <label for="" [translate]="'LABELS.QUOTE_NEG_DIRECTION'"
            >Other Directions</label
          >
          <span class="form-control">{{ negotiatedPrice.other_details }}</span>
        </div>
      </div>
    </div>
  </fieldset>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="activeModal.dismiss('')"
    [translate]="'BUTTONS.CLOSE'"
  >
    <i class="fas fa-times"></i> Close</button
  >
  <button
    type="button"
    *ngIf="negotiatedPrice"
    class="btn btn-primary"
    (click)="updateQuotation()"
    [translate]="'BUTTONS.UPDATE_QUOTATION'"
  >
    <i class="fas fa-edit"></i> Update Quotation
  </button>
</div>
